import { connect } from 'react-redux';
import {
  selectInteractionMonitoringActiveColumns,
  areAllColNotActive,
  selectTimeFormat,
  totalRatio,
  activeMenuItems,
  areAllActive,
} from '../../redux/modules/columnFilterMenus/selectors';
import { setCurrentEntity, fetchData } from '../../redux/modules/entities';
import {
  updateTableData,
  setExpanded,
  setInteractionsDetailExpand,
  setActiveParticipantsExpand,
  setInteractionMonitoringExpanded,
  setSorted,
  setSelected,
  removeSelected,
  startInteractionMonitoring,
  getExtensions,
  onSeenNewestMessage,
  setLastScrollPosition,
} from '../../redux/modules/reporting/interactionMonitoring';
import {
  updateSkillsColumnFilter,
  updateGroupsColumnFilter,
  toggleTimeFormat,
} from '../../redux/modules/columnFilterMenus';
import {
  selectInteractionMonitoringTableData,
  selectInteractionMonitoringSorted,
  selectInteractionMonitoringExpanded,
  selectInteractionMonitoringDetailsExpanded,
  selectActiveParticipantExpanded,
  selectInteractionMonitoringHistoryExpanded,
  selectInteractionMonitoringSelected,
  userHasViewAllMonitoredCallsPermission,
  userHasMonitorAllCallsPermission,
  selectExtensions,
  isFetchingUserExtensions,
} from '../../redux/modules/reporting/interactionMonitoring/selectors';
import {
  selectSupervisorToolbarSilentMonitoringInteractionId,
  selectSupervisorToolbarSilentMonitoringStatus,
  selectLoadingUserStatus,
} from '../../redux/modules/supervisorToolbar/selectors';
import { getCurrentAgentId } from '../../redux/modules/userData/selectors';
import { getHelpLink } from '../EntityTable/selectors';
import { entitiesMetaData } from '../../redux/modules/entities/metaData';

import Layout from './layout';
import { isInIframe } from 'serenova-js-utils/browser';

const TABLE_TYPE = 'interactionMonitoring';

export const mapStateToProps = (state, props) => ({
  pageTitle: entitiesMetaData[TABLE_TYPE] ? entitiesMetaData[TABLE_TYPE].pageTitle : '',
  pageHelpLink: getHelpLink(state),
  getCurrentAgentId: getCurrentAgentId(state),
  areAllColNotActive: areAllColNotActive(state, {
    menuType: 'Columns',
    tableType: TABLE_TYPE,
  }),
  activeGroupFilters: activeMenuItems(state, { tableType: TABLE_TYPE, menuType: 'Groups' }).toJS(),
  activeSkillFilters: activeMenuItems(state, { tableType: TABLE_TYPE, menuType: 'Skills' }).toJS(),
  groupsAreAllActive: areAllActive(state, { tableType: TABLE_TYPE, menuType: 'Groups' }),
  skillsAreAllActive: areAllActive(state, { tableType: TABLE_TYPE, menuType: 'Skills' }),
  extensions: selectExtensions(state),
  totalRatio: totalRatio(state, props),
  activeColumns: selectInteractionMonitoringActiveColumns(state, props),
  twelveHourFormat: selectTimeFormat(state, props),
  tableData: selectInteractionMonitoringTableData(state, props),
  expanded: selectInteractionMonitoringExpanded(state, props),
  interactionsDetailsExpanded: selectInteractionMonitoringDetailsExpanded(state, props),
  activeParticipantExpanded: selectActiveParticipantExpanded(state, props),
  interactionMonitoringExpanded: selectInteractionMonitoringHistoryExpanded(state, props),
  selected: selectInteractionMonitoringSelected(state, props),
  sorted: selectInteractionMonitoringSorted(state, props),
  monitoredId: selectSupervisorToolbarSilentMonitoringInteractionId(state, props),
  voiceMonitoringStatus: selectSupervisorToolbarSilentMonitoringStatus(state, props),
  userHasViewAllMonitoredCallsPermission: userHasViewAllMonitoredCallsPermission(state),
  userHasMonitorAllCallsPermission: userHasMonitorAllCallsPermission(state),
  insideIframe: !isInIframe(),
  loadingUserStatus: selectLoadingUserStatus(state),
  isFetchingUserExtensions: isFetchingUserExtensions(state),
});

export const actions = {
  toggleTimeFormat,
  updateTableData,
  updateSkillsColumnFilter,
  updateGroupsColumnFilter,
  setExpanded,
  setInteractionsDetailExpand,
  setActiveParticipantsExpand,
  setInteractionMonitoringExpanded,
  setSelected,
  setSorted,
  removeSelected,
  fetchData,
  startInteractionMonitoring,
  getExtensions,
  setCurrentEntity,
  onSeenNewestMessage,
  setLastScrollPosition,
};

export default connect(mapStateToProps, actions)(Layout);
